import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Login from "../login/login";
import Dasboard from "../dasboard/dashboard";
import React from 'react';
import clienteAxios from "../../axios";
import ModalConfirm from '../ModalConfirm';

const Mesas = () => {
    
    const [mesas, setMesas] = useState([]);
    const [nuevaMesa, setNuevaMesa] = useState({ numero_mesa: "", capacidad: "" });
    const [editandoMesaId, setEditandoMesaId] = useState(null);
    const [mesaEditada, setMesaEditada] = useState({ numero_mesa: "", capacidad: "" });
    const [mesaSeleccionada, setMesaSeleccionada] = useState(null);
    const [mensajeExito, setMensajeExito] = useState(false);


    const [estadosPorMesa, setEstadosPorMesa] = useState({});
    const [estados, setEstados] = useState([]);
    const [nuevoEstado, setNuevoEstado] = useState("");
    const [editandoEstadoId, setEditandoEstadoId] = useState(null);
    const [estadoEditado, setEstadoEditado] = useState("");
    const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [actionToConfirm, setActionToConfirm] = useState(null);
    const [itemToDelete, setItemToDelete] = useState(null);

    const navigate = useNavigate();
    const inputRef = useRef(null);

  

 


    useEffect(() => {
        obtenerMesas();
        obtenerTodosLosEstados();
    }, []);


    // Obtener lista de mesas
    const obtenerMesas = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "mesas"
            });
            setMesas(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };



    // Obtener todos los estados de mesas al cargar el componente
    const obtenerTodosLosEstados = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "estado_mesas"
            });
        
            setEstados(response.data.data);  // Guardamos todos los estados
        } catch (error) {
            console.log(error);
        }
    };




    // Filtrar los estados por mesa seleccionada
    const obtenerEstadosPorMesaSeleccionada = (idmesa) => {
        const estadosFiltrados = (estados[0] || []).filter(estado => estado.mesa_id === idmesa);



        setEstadosPorMesa(prevEstados => ({
            ...prevEstados,
            [idmesa]: estadosFiltrados
        }));
    };


    const confirmarAccion = (accion, idItem) => {
        setShowConfirmModal(true);
        setActionToConfirm(accion);
        setItemToDelete(idItem);
    };

    const cerrarModalConfirmacion = () => {
        setShowConfirmModal(false);
        setActionToConfirm(null);
        setItemToDelete(null);
    };

    //Funcion para agregar mesa
    const handleAgregarMesa = async (e) => {
        e.preventDefault();

        if (nuevaMesa.numero_mesa.trim() === "" || nuevaMesa.capacidad.trim() === "") {
            alert("La mesa debe tener un número y capacidad.");
            return;
        }

        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "mesas",
                restaurante_id: "1",
                numero_mesa: nuevaMesa.numero_mesa,
                capacidad: nuevaMesa.capacidad
            });

            setNuevaMesa({ numero_mesa: "", capacidad: "" });
            setMensajeExito(true);
            setTimeout(() => setMensajeExito(false), 3000);
            obtenerMesas();
        } catch (error) {
            console.log(error);
        }
    };

    //Funcion para agregar o actualizar el estado de la mesa
    const handleAgregarEstado = async (estadoSeleccionado) => {
        if (!mesaSeleccionada || !estadoSeleccionado) {
            alert("Debe seleccionar una mesa y un estado.");
            return;
        }

        // Verificamos si ya existe un estado para esta mesa
        const estadoActual = estadosPorMesa[mesaSeleccionada]?.[0];

        try {
            if (estadoActual) {
                // Si ya existe un estado, actualizamos el estado existente
                await clienteAxios.post("/api/sp", {
                    sp: "tools",
                    op: "Actualizar",
                    modulo: "estado_mesas",
                    id: estadoActual.id,  // Usamos el ID del estado existente para actualizar
                    mesa_id: mesaSeleccionada,  // Asegúrate de enviar el mesa_id
                    estado: estadoSeleccionado  // Registramos el nuevo estado seleccionado
                });
            } else {
                // Si no existe un estado, lo agregamos
                await clienteAxios.post("/api/sp", {
                    sp: "tools",
                    op: "Agregar",
                    modulo: "estado_mesas",
                    mesa_id: mesaSeleccionada,  // Asegúrate de enviar el mesa_id
                    estado: estadoSeleccionado  // Registramos el nuevo estado seleccionado
                });
            }

            // Actualizamos los estados localmente para reflejar el nuevo estado inmediatamente
            setEstadosPorMesa(prevEstados => ({
                ...prevEstados,
                [mesaSeleccionada]: [{ id: estadoActual ? estadoActual.id : Date.now(), estado: estadoSeleccionado }]  // Actualizamos localmente
            }));

        } catch (error) {
            console.log(error);
        }
    };





    const editarMesa = (idmesa, mesaActual) => {
        setEditandoMesaId(idmesa);
        setMesaEditada(mesaActual);
        setMesaSeleccionada(idmesa);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current.setSelectionRange(0, 0);
            }
        }, 0);
    };

    const guardarMesaEditada = async (idmesa) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "mesas",
                id: idmesa,
                restaurante_id: "1",
                numero_mesa: mesaEditada.numero_mesa,
                capacidad: mesaEditada.capacidad
            });

            setEditandoMesaId(null);
            setMesaSeleccionada(null);
            obtenerMesas();
        } catch (error) {
            console.log(error);
        }
    };

    // Dentro de borrarMesa o borrarEstado
    const borrarMesa = async (idmesa) => {        
        try {
            const data = {
                sp: "tools",
                op: "Eliminiar",
                modulo: "mesas",
                id: idmesa
            };          
            const response = await clienteAxios.post("/api/sp", data);        
            obtenerMesas(); // Actualizar las mesas después de la eliminación
            cerrarModalConfirmacion();
        } catch (error) {
            console.log("Error al eliminar la mesa:", error); // Muestra el error si ocurre.
        }
    };



    const editarEstado = (idestado, estadoActual) => {
        setEditandoEstadoId(idestado);
        setEstadoEditado(estadoActual);
    };

    const borrarEstado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",  // Asegúrate que el typo es "Eliminar" si corriges el backend
                modulo: "estado_mesas",
                id: itemToDelete
            });

            // Filtrar manualmente el estado eliminado del array de estados en el front-end
            setEstadosPorMesa((prevEstados) => ({
                ...prevEstados,
                [mesaSeleccionada]: prevEstados[mesaSeleccionada].filter(estado => estado.id !== itemToDelete)
            }));

            cerrarModalConfirmacion();
        } catch (error) {
            console.log(error);
        }
    };



    const ejecutarAccionConfirmada = () => {
        if (actionToConfirm === 'borrarMesa') {
            borrarMesa(mesaSeleccionada);  // Elimina la mesa seleccionada
        } else if (actionToConfirm === 'borrarEstado') {
            borrarEstado(estadoSeleccionado);  // Elimina el estado seleccionado
            obtenerEstadosPorMesaSeleccionada(mesaSeleccionada);
        }
    };



    const cancelarSeleccion = () => {
        setMesaSeleccionada(null);
        setEditandoMesaId(null);

    };



    return (
        <>
            <ModalConfirm
                show={showConfirmModal}
                message={`¿Estás seguro de que quieres ${actionToConfirm === 'borrarMesa' ? 'borrar esta mesa' : 'borrar este estado'}?`}
                onConfirm={ejecutarAccionConfirmada}  // Llamada directa sin pasar `itemToDelete`
                onCancel={cerrarModalConfirmacion}
            />            
                <>
                    <Dasboard  />
                    <main className="-mt-32">
                        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                                <h2 className="text-2xl font-bold mb-6 mt-4">Mesas</h2>
                                <ul>
                                    {mesas.map((mesa) => (
                                        <li key={mesa.id}
                                            className={`border-4 p-4 rounded-lg mb-4 cursor-pointer ${estadosPorMesa[mesa.id]?.[0]?.estado === "Disponible"
                                                ? "border-green-500"
                                                : estadosPorMesa[mesa.id]?.[0]?.estado === "Ocupado"
                                                    ? "border-red-500"
                                                    : estadosPorMesa[mesa.id]?.[0]?.estado === "Reservado"
                                                        ? "border-yellow-500"
                                                        : ""
                                                }`}
                                            onClick={() => {
                                                obtenerMesas();
                                                obtenerTodosLosEstados();
                                                setMesaSeleccionada(mesa.id);
                                                obtenerEstadosPorMesaSeleccionada(mesa.id);
                                            }}
                                        >
                                            <div>
                                                {editandoMesaId === mesa.id ? (

                                                    <>
                                                        <div className="mb-4">
                                                            <input
                                                                type="text"
                                                                ref={inputRef}
                                                                value={mesaEditada.numero_mesa}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    // Solo permite números y un máximo de 5 caracteres
                                                                    if (/^\d*$/.test(value) && value.length <= 5) {
                                                                        setMesaEditada({ ...mesaEditada, numero_mesa: value });
                                                                    }
                                                                }}
                                                                placeholder="Numero de mesa"
                                                                className="border rounded-lg p-2 mr-2"
                                                                maxLength={5} // Esto limita la longitud en el input visualmente
                                                            />

                                                            <input
                                                                type="text"
                                                                value={mesaEditada.capacidad}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    // Solo permite números y un máximo de 5 caracteres
                                                                    if (/^\d*$/.test(value) && value.length <= 5) {
                                                                        setMesaEditada({ ...mesaEditada, capacidad: value });
                                                                    }
                                                                }}
                                                                placeholder="Capacidad"
                                                                className="border rounded-lg p-2 mr-2"
                                                                maxLength={5}
                                                            />

                                                            <button onClick={() => guardarMesaEditada(mesa.id)}
                                                                className="bg-green-500 text-white rounded px-2 py-1 mr-2">Guardar</button>
                                                            <button onClick={() => setEditandoMesaId(null)}
                                                                className="bg-gray-500 text-white rounded px-2 py-1">Cancelar</button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="text-xl font-semibold ">{`Mesa ${mesa.numero_mesa} - Capacidad: ${mesa.capacidad}`}</span>

                                                    </>
                                                )}
                                            </div>

                                            {mesaSeleccionada === mesa.id && (
                                                <div className="relative">
                                                    {/* Botón "X" en la esquina superior derecha para cancelar */}
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            cancelarSeleccion();
                                                        }}
                                                        className="absolute top-[-2.5rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                    >
                                                        &times;
                                                    </button>
                                                    <div className="mt-2 flex items-center">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                editarMesa(mesa.id, { numero_mesa: "", capacidad: "" });
                                                            }}
                                                            className="bg-gray-500 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                        >
                                                            Editar Mesa
                                                        </button>

                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                confirmarAccion('borrarMesa', mesa.id);
                                                            }}
                                                            className="bg-red-600 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                        >
                                                            Eliminar Mesa
                                                        </button>
                                                    </div>
                                                </div>
                                            )}


                                            {mesaSeleccionada === mesa.id && (
                                                <>
                                                    <h3 className="text-lg font-semibold mt-4">Estado de la mesa</h3>

                                                    {/* Si hay estados para la mesa seleccionada, los mostramos */}
                                                    {estadosPorMesa[mesa.id]?.length > 0 ? (
                                                        <ul className="mt-2">
                                                            {estadosPorMesa[mesa.id].map((estado) => (
                                                                <li key={estado.id} className="border p-2 mb-2 cursor-pointer"
                                                                    onClick={() => setEstadoSeleccionado(estado.id)}>

                                                                    {editandoEstadoId === estado.id ? (
                                                                        <>
                                                                            {/* Reemplazamos el input por los tres botones */}
                                                                            <h3 className="text-lg font-semibold mt-4">Estado de la mesa</h3>
                                                                            <div className="mt-4 flex gap-4">
                                                                                <button
                                                                                    onClick={() => handleAgregarEstado("Disponible")}
                                                                                    className="bg-green-500 text-white rounded px-4 py-2"
                                                                                >
                                                                                    Disponible
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => handleAgregarEstado("Ocupado")}
                                                                                    className="bg-red-500 text-white rounded px-4 py-2"
                                                                                >
                                                                                    Ocupado
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => handleAgregarEstado("Reservado")}
                                                                                    className="bg-yellow-500 text-white rounded px-4 py-2"
                                                                                >
                                                                                    Reservado
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span>{estado.estado}</span>

                                                                            {estadoSeleccionado === estado.id && (
                                                                                <>
                                                                                    <button
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            editarEstado(estado.id, estado.estado);
                                                                                        }}
                                                                                        className="ml-2 bg-blue-500 text-white rounded px-2 py-1"
                                                                                    >
                                                                                        Editar Estado
                                                                                    </button>

                                                                                    <button
                                                                                        onClick={() => confirmarAccion('borrarEstado', estado.id)}
                                                                                        className="ml-2 bg-red-500 text-white rounded px-2 py-1"
                                                                                    >
                                                                                        Borrar Estado
                                                                                    </button>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p className="mt-2">No hay estados para esta mesa.</p>
                                                    )}


                                                    {/* Formulario para agregar nuevo estado */}
                                                    <div className="mt-4 gap-4 space-y-2 space-x-2 ">
                                                        <button
                                                            onClick={() => handleAgregarEstado("Disponible")}
                                                            className="bg-green-500 text-white rounded px-4 py-2"
                                                        >
                                                            Disponible
                                                        </button>
                                                        <button
                                                            onClick={() => handleAgregarEstado("Ocupado")}
                                                            className="bg-red-500 text-white rounded px-4 py-2"
                                                        >
                                                            Ocupado
                                                        </button>
                                                        <button
                                                            onClick={() => handleAgregarEstado("Reservado")}
                                                            className="bg-yellow-500 text-white rounded px-4 py-2"
                                                        >
                                                            Reservado
                                                        </button>
                                                    </div>
                                                </>
                                            )}

                                        </li>
                                    ))}
                                </ul>

                                <h2 className="font-bold mb-6 mt-8">Agregar nueva mesa</h2>
                                <form onSubmit={handleAgregarMesa}>
                                    <input
                                        type="text"
                                        value={nuevaMesa.numero_mesa}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Solo permite números y un máximo de 5 caracteres
                                            if (/^\d*$/.test(value) && value.length <= 5) {
                                                setNuevaMesa({ ...nuevaMesa, numero_mesa: value });
                                            }
                                        }}
                                        placeholder="Número de mesa"
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={5}
                                    />

                                    <input
                                        type="text"
                                        value={nuevaMesa.capacidad}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Solo permite números y un máximo de 5 caracteres
                                            if (/^\d*$/.test(value) && value.length <= 5) {
                                                setNuevaMesa({ ...nuevaMesa, capacidad: value });
                                            }
                                        }}
                                        placeholder="Capacidad"
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={5}
                                    />

                                    <button type="submit" className="bg-green-500 rounded text-white px-2 py-1 mt-2">
                                        Agregar
                                    </button>
                                </form>

                                {mensajeExito && (
                                    <p className="text-pink-500 mt-2">Mesa agregada exitosamente</p>
                                )}
                            </div>
                        </div>
                    </main>
                </>
            
        </>
    );
};

export default Mesas;
